import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { WHCM_DISABLED_ITEM_COLOR, WHCM_ITEM_COLOR } from "../constants";
export var getWindowsHighContrastStyles = function getWindowsHighContrastStyles(isDisabled) {
  return _objectSpread(_objectSpread({}, isDisabled && {
    svg: {
      display: 'block',
      position: 'absolute',
      top: '-2px',
      left: '-2px',
      // Windows system color for disabled items in WHCM
      backgroundColor: WHCM_DISABLED_ITEM_COLOR
    }
  }), {}, {
    '.tick': {
      opacity: 0,
      // Windows system color for general items in WHCM
      stroke: WHCM_ITEM_COLOR,
      strokeDasharray: '0, 20000',
      transition: 'stroke-dasharray 0.2s, opacity 0.2s',
      transitionDelay: '0.1s',
      transitionTimingFunction: 'ease'
    }
  });
};